import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';

import { getCountries } from 'services/countryService';
import { getSchoolsFiltersV2 } from 'services/schoolService';

withFilterUtils.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
};

export default function withFilterUtils(WrappedComponent) {
  const EnhancedComponent = forwardRef((props, ref) => {
    const { data: countries, isLoading: countriesLoading } = useQuery({
      queryFn: () => getCountries(),
      queryKey: ['countries'],
      refetchOnWindowFocus: false,
      staleTime: 10 * 5000,
    });
    const { data: schoolsFilters, isLoading: schoolLoading } = useQuery({
      queryFn: () => getSchoolsFiltersV2(),
      queryKey: ['filterData'],
      refetchOnWindowFocus: false,
      staleTime: 10 * 5000,
    });

    if (countriesLoading || schoolLoading) return null;

    return (
      <WrappedComponent
        countries={countries}
        ref={ref}
        schoolsFilters={schoolsFilters}
        {...props}
      />
    );
  });

  EnhancedComponent.displayName = 'EnhancedComponent';

  return EnhancedComponent;
}
